import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_backendurl,
    prepareHeaders: (headers) => {
      if (typeof Storage !== 'undefined') {
        const user = JSON.parse(localStorage.getItem('RaselListing'))
        if (user?.token) headers.set('Authorization', `Bearer ${user?.token}`)
      }
      return headers
    },
  }),
  endpoints: (builder) => ({
    sendNotification: builder.mutation({
      query(data) {
        return {
          url: `api/noti/send-notification`,
          method: 'POST',
          body: data,
        }
      },
    }),
  }),
})

export const { useSendNotificationMutation } = notificationApi
